import React, {Component} from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import Switch from 'react-switch';


import 'style/components/notification/cookie-manager.scss';

class CookiesManager extends Component {

    static propTypes = {
        permission: PropTypes.string, // Tag with the name of the permission
        label:      PropTypes.string, // Label with the name of the permission
        onChange:   PropTypes.func, // Function to call when value change
        disabled:   PropTypes.bool, // true if the switch is disabled
        value:      PropTypes.bool // Initial value
    };


    state = {
        isManagePermissonsOpen: false
    };

    /**
     * Set this to handlers
     */
    componentWillMount() {
        this.handleChange = this.handleChange.bind(this);
    }


    handleChange(e) {
        const {onChange, permission} = this.props;

        onChange && onChange(permission, e);
    }

    render() {
        const {value, intl: {formatMessage}, label, disabled, description} = this.props;


        return (
            <div className={'cookie-manager'}>
                <span>{formatMessage({id: label})}</span>
                <Switch
                    onChange={e => this.handleChange(e)}
                    checked={value}
                    onColor="#b8b9fb"
                    onHandleColor="#53B7E8"
                    handleDiameter={20}
                    uncheckedIcon={false}
                    checkedIcon={false}
                    boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                    height={15}
                    width={36}
                    disabled={disabled}
                    className="react-switch"
                    id="material-switch"
                />
                <div>
                    {formatMessage({id: description})}
                </div>
            </div>
        );
    }
}

export default injectIntl(CookiesManager);



// WEBPACK FOOTER //
// ./src/components/notifications/CookiesManager.jsx